import React from "react";
import { includes } from "ramda";
import Select from "@material-ui/core/Select";
import { InputLabel, MenuItem } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  approved: {
    color: theme.palette.approved,
  },

  inactive: {
    color: theme.palette.inactive,
  },

  takedown: {
    color: theme.palette.takedown,
  },

  pending: {
    color: theme.palette.pending,
  },

  rejected: {
    color: theme.palette.rejected,
  },

  default: {
    color: theme.palette.primary.dark,
  },

  title: {
    fontSize: "1.8rem",
  },

  formControl: {
    bottom: 3,
  },

  inputLabel: {
    transform: "translate(0, 14px) scale(1)",
  },

  shrink: {
    transform: "translate(0, -12px) scale(0.85)",
  },
}));

const chooseColor = (value, classes) => {
  switch (value) {
    case "APPROVED":
    case "ACTIVE":
      return classes.approved;
    case "PENDING":
      return classes.pending;
    case "REJECTED":
    case "DELETED":
      return classes.rejected;
    case "TAKEDOWN":
      return classes.takedown;
    case "INACTIVE":
      return classes.inactive;
    default:
      return classes.default;
  }
};

const MediaStatusSelect = React.forwardRef((props, ref) => {
  const { onChange, value, mediaType, FormControlProps, ...otherProps } = props;
  const classes = useStyles();
  const color = chooseColor(value, classes);

  return (
    <FormControl
      fullWidth
      className={classes.formControl}
      {...FormControlProps}
    >
      <InputLabel
        htmlFor={`${mediaType}-status`}
        classes={{
          formControl: classes.inputLabel,
          shrink: classes.shrink,
        }}
      >
        Status
      </InputLabel>
      <Select
        style={{ marginTop: 0 }}
        classes={{ root: color }}
        value={value}
        onChange={onChange}
        inputProps={{
          name: `${mediaType}-status`,
          id: `${mediaType}-status`,
        }}
        MenuProps={{
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "left",
          },
          transformOrigin: {
            vertical: "top",
            horizontal: "left",
          },
          getContentAnchorEl: null,
        }}
        {...otherProps}
      >
        {includes(mediaType, ["anthology", "collection", "content"]) && (
          <MenuItem className={classes.default} value="" key="NO_STATUS">
            <em>None</em>
          </MenuItem>
        )}

        {mediaType === "content" && (
          <MenuItem
            className={classes.approved}
            value="APPROVED"
            key="APPROVED"
          >
            Approved
          </MenuItem>
        )}

        {mediaType === "content" && (
          <MenuItem className={classes.pending} value="PENDING" key="PENDING">
            Pending
          </MenuItem>
        )}

        {mediaType === "content" && (
          <MenuItem
            className={classes.rejected}
            value="REJECTED"
            key="REJECTED"
          >
            Rejected
          </MenuItem>
        )}

        {mediaType === "content" && (
          <MenuItem
            className={classes.takedown}
            value="TAKEDOWN"
            key="TAKEDOWN"
          >
            Takedown
          </MenuItem>
        )}

        {includes(mediaType, ["module", "anthology", "collection"]) && (
          <MenuItem className={classes.approved} value="ACTIVE" key="ACTIVE">
            Active
          </MenuItem>
        )}

        {mediaType === "module" && (
          <MenuItem className={classes.pending} value="INACTIVE" key="INACTIVE">
            Inactive
          </MenuItem>
        )}

        {includes(mediaType, ["module", "anthology", "collection"]) && (
          <MenuItem className={classes.rejected} value="DELETED" key="DELETED">
            Deleted
          </MenuItem>
        )}
      </Select>
    </FormControl>
  );
});

export default MediaStatusSelect;
